/* @flow weak */
import ReactDOM from 'react-dom';

import 'components/styles/DateTimePickerShared.scss';

// XXX kill this mixin. Complicates DatePickerInput
const DateTimePickerMixin = {

  getInitialState() {
    return {
      opened: this.props.autofocus,
      focused: false,
    };
  },

  updatePositionForTopPlacement() {
    const nodes = this.getPopupNodes();
    for (let i = 0; i < nodes.length; i++) {
      const node = nodes[i];
      const popup = node.getElementsByClassName('rw-popup')[0];
      if (popup) {
        popup.style.top = (-parseInt(popup.offsetHeight, 10) - 36) + 'px';
      }
    }
  },

  getPopupNodes() {
    if (this.refs.picker) {
      const root = ReactDOM.findDOMNode(this.refs.picker);
      return root.getElementsByClassName('rw-popup-container');
    }
    return [];
  },

  handleClick(e) {
    let clickedPopup = false;
    [].forEach.call(this.getPopupNodes(), n => {
      if (n.contains(e.target)) {
        clickedPopup = true;
      }
    });

    if (!clickedPopup) {
      // if we didn't click the popup, toggle the popup
      this.setState({ opened: !this.state.opened });
    }

    // Hack to update positioning based on the new height
    if (this.props.placement === 'top') {
      setTimeout(() => this.updatePositionForTopPlacement(), 1);
    }
  },

  isOpen() {
    return this.state.opened;
  },

  isFocused() {
    return this.state.focused;
  },

  closePopup() {
    if (this.state.opened) {
      this.setState({ opened: false });
    }
  },

  handleFocus() {
    this.setState({ focused: true });
  },

  handleBlur() {
    this.setState({ focused: false });
    this.closePopup();
  },

  handleChange() {
    this.setState({ opened: false });
  },
};

export default DateTimePickerMixin;



// WEBPACK FOOTER //
// ./src/components/mixins/DateTimePickerMixin.js